module.exports = __webpack_public_path__ + "static/media/tagNuevo2.2913b1a7.png";